import { useState, useEffect, useRef } from 'react';
import { consumeToast } from '../utils/toast';

const TYPE_STYLE = {
  error: { bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.3)', color: '#f87171', icon: '#f87171' },
  info:  { bg: 'rgba(71,158,195,0.12)', border: 'rgba(71,158,195,0.3)', color: '#7dd3fc', icon: '#479EC3' },
};

export default function Toast() {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);
  // Read once at render time so StrictMode's double-effect invocation both see the value
  const initialToast = useRef(consumeToast());

  useEffect(() => {
    const t = initialToast.current;
    if (t) {
      setToast(t);
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!toast || !visible) return null;

  const s = TYPE_STYLE[toast.type] || TYPE_STYLE.info;

  return (
    <div style={{
      position: 'fixed', bottom: 28, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, display: 'flex', alignItems: 'center', gap: 10,
      padding: '12px 18px', borderRadius: 10,
      background: s.bg, border: `1px solid ${s.border}`,
      backdropFilter: 'blur(12px)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      color: s.color, fontSize: 13.5, fontWeight: 500,
      animation: 'toast-in 0.2s ease',
      whiteSpace: 'nowrap',
    }}>
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={s.icon} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {toast.message}
      <button onClick={() => setVisible(false)} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        color: s.color, opacity: 0.6, padding: '0 0 0 4px', lineHeight: 1, fontSize: 16,
      }}>×</button>
      <style>{`@keyframes toast-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
}
